function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".heart-1{fill:#fff;}.filled .heart-1{fill:#ff7baa;}.heart-2{fill:none;stroke:#e26f9e;stroke-miterlimit:10;stroke-width:3px;}.heart-3{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "heart");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "heart-1",
  d: "M21.15,35.77S50.87,17.27,37.22,4.05c-8-7.75-16.07,4.66-16.07,4.66S13.09-3.7,5.09,4.05C-8.57,17.27,21.15,35.77,21.15,35.77"
}), /*#__PURE__*/React.createElement("path", {
  className: "heart-2",
  d: "M21.15,35.77S50.87,17.27,37.22,4.05c-8-7.75-16.07,4.66-16.07,4.66S13.09-3.7,5.09,4.05C-8.57,17.27,21.15,35.77,21.15,35.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "heart-3",
  d: "M14.29,7.35a2.81,2.81,0,1,1-2.81-2.81,2.81,2.81,0,0,1,2.81,2.81"
})));

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42.3 37.54",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.9fb4b364.svg";
export { ForwardRef as ReactComponent };